import { useEffect } from 'react';
import { getToken } from 'firebase/messaging';
import { api } from '../services/api';
import { useAppStore } from '../store/useAppStore';
import {
  getPushPromptStorageKey,
  getPushTokenStorageKey,
  getUserPushStorageKey,
  isPushSupported,
  isSuccessfulResponse,
} from '../utils/pushNotifications';
import {
  getBrowserMessaging,
  getFirebaseVapidKey,
  isFirebaseMessagingConfigured,
} from '../utils/firebaseMessaging';

const PushNotificationBootstrap = () => {
  const { user } = useAppStore();
  const userStorageKey = getUserPushStorageKey(user);

  useEffect(() => {
    if (!userStorageKey) {
      return;
    }

    if (!isPushSupported() || !isFirebaseMessagingConfigured()) {
      return;
    }

    let isCancelled = false;

    const bootstrapPushNotifications = async () => {
      try {
        const promptStorageKey = getPushPromptStorageKey(userStorageKey);
        let permission = Notification.permission;

        if (permission === 'default' && !window.localStorage.getItem(promptStorageKey)) {
          window.localStorage.setItem(promptStorageKey, 'true');
          permission = await Notification.requestPermission();
        }

        if (permission !== 'granted' || isCancelled) {
          return;
        }

        const registration = await navigator.serviceWorker.ready;
        const messaging = await getBrowserMessaging();

        if (!messaging || isCancelled) {
          return;
        }

        const token = await getToken(messaging, {
          vapidKey: getFirebaseVapidKey(),
          serviceWorkerRegistration: registration,
        });

        if (!token || isCancelled) {
          return;
        }

        const tokenStorageKey = getPushTokenStorageKey(userStorageKey);

        if (window.localStorage.getItem(tokenStorageKey) === token) {
          return;
        }

        const response = await api.saveNotificationToken({
          platform: 'web',
          token,
        });

        if (isSuccessfulResponse(response) && !isCancelled) {
          window.localStorage.setItem(tokenStorageKey, token);
        }
      } catch (error) {
        console.error('Push notification bootstrap error:', error);
      }
    };

    void bootstrapPushNotifications();

    return () => {
      isCancelled = true;
    };
  }, [userStorageKey]);
  return null;
};

export default PushNotificationBootstrap;
